import arrowImage from '../../../assets/img/icons/google.svg';

type GoogleIconProps = {
    alt?: string;
    className?: string | null;
};

function GoogleIcon({ alt = 'Google', className = null }: GoogleIconProps) {
    return <img src={arrowImage} className={className || undefined} alt={alt} />;
}

export default GoogleIcon;
